module.exports = __webpack_public_path__ + "static/img/eicad_item1.80084034.png";